import React, { useEffect, useState } from "react";
import { camelCase } from "change-case";

import { DEFAULT_SIZE, Icon, IconBaseProps, IconName, IconProps } from "./icon";

export type DynamicIconProps = {
  name: IconName;
} & IconBaseProps;

export const DynamicIcon = ({
  ["data-testid"]: dataTestId,
  name,
  className,
  allyTitle,
  size = DEFAULT_SIZE,
  ...props
}: DynamicIconProps) => {
   
  const [asset, setAsset] = useState<IconProps["svg"]>();

  useEffect(() => {
    const importAsset = async () => {
      try {
        const module = await import(`./assets/${name}.ts`);
        setAsset(module[camelCase(name, { mergeAmbiguousCharacters: true })]);
      } catch (error) {
         
        console.error(`Error importing asset "${name}":`, error);
      }
    };

    importAsset();
  }, [name]);

  return asset ? (
    <Icon
      allyTitle={allyTitle}
      className={className}
      size={size}
      data-testid={dataTestId}
      svg={asset}
      {...props}
    />
  ) : null;
};

DynamicIcon.displayName = "DynamicIcon";
